const merge = (arr) => {
  let intervals = [...arr];
  //Sort the intervals based on the start time
  intervals.sort((a, b) => (a[0] !== b[0] ? a[0] - b[0] : a[1] - b[1]));
  //Iterate the intervals
  for (let i = 0; i < intervals.length - 1; i++) {
    //Get the start and end time of each interval
    const [start1, end1] = intervals[i];
    const [start2, end2] = intervals[i + 1];

    //if there is overlapp then merge the index
    if (start2 <= end1) {
      //Get the min of start of interval and max of end.
      const newInterval = [Math.min(start1, start2), Math.max(end1, end2)];

      //Add the new interval to the array
      intervals.splice(i, 2, newInterval);

      //keep the i at the same index to continue the comparing
      i--;
    }
  }

  //Return the merged intervals.
  return intervals;
};

export default merge;
